import React, { useState } from 'react';
import './SideDrawer.css'; // <-- Add this import

export default function SideDrawer({ open, onClose, onNavigate, user, onLogout }) {
  // State to manage mobile accordion menus
  const [expandedSection, setExpandedSection] = useState(null);

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const handleRoute = (route) => {
    onNavigate(route);
    onClose(); // Auto-close the drawer after clicking a link
  };

  // User Profile Variables
  const displayName = user?.displayName || "Student";
  const email = user?.email || "";
  const avatarUrl = user?.photoURL || `https://ui-avatars.com/api/?name=${encodeURIComponent(displayName)}&background=f1f5f9&color=0f172a`;

  return (
    <>
      <div 
        className={`drawer-overlay ${open ? 'active' : ''}`} 
        onClick={onClose}
      ></div>
      
      <aside className={`side-drawer ${open ? 'active' : ''}`} style={{ display: 'flex', flexDirection: 'column', padding: 0 }}>
        
        {/* 1. Drawer Header & Profile (Merged for clean layout) */}
        <div className="drawer-header" style={{ padding: '20px', backgroundColor: '#f8fafc', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', borderBottom: '1px solid #e2e8f0' }}>
          
          {/* Profile Section */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <img src={avatarUrl} alt="Profile" style={{ width: '48px', height: '48px', borderRadius: '50%' }} />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontWeight: 'bold', color: '#0f172a' }}>{displayName}</span>
              <span style={{ fontSize: '0.85rem', color: '#64748b', wordBreak: 'break-word' }}>{email}</span>
            </div>
          </div>

          {/* Prominent Close Button */}
          <button className="close-btn" onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#0f172a', padding: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        
        {/* 2. Scrollable Navigation */}
        <nav className="drawer-nav" style={{ flex: 1, overflowY: 'auto', padding: '10px 0' }}>
          
          {/* Main Links */}
          <button className="drawer-link" onClick={() => handleRoute('folders')}>
            Home
          </button>
          
          <button className="drawer-link" onClick={() => handleRoute('posts')}>
            All Modules
          </button>

          {/* Catalog Accordion */}
          <div className="drawer-accordion-item">
            <button 
              className="drawer-link accordion-trigger" 
              onClick={() => toggleSection('catalog')}
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
            >
              Course Catalog
              <svg 
                width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"
                style={{ transform: expandedSection === 'catalog' ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="m6 9 6 6 6-6"/>
              </svg>
            </button>
            
            {/* Expanded Catalog Links */}
            {expandedSection === 'catalog' && (
              <div className="accordion-content" style={{ backgroundColor: '#f8fafc', padding: '10px 20px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <div className="mobile-catalog-group">
                  <strong style={{ fontSize: '0.85rem', color: '#64748b', textTransform: 'uppercase' }}>Quantitative & Math</strong>
                  <a href="/Subject-Wise/Mathematics" style={{ display: 'block', margin: '8px 0', color: '#0f172a', textDecoration: 'none' }}>Mathematics</a>
                  <a href="/Subject-Wise/Reasoning" style={{ display: 'block', margin: '8px 0', color: '#0f172a', textDecoration: 'none' }}>Logical Reasoning</a>
                </div>
                <div className="mobile-catalog-group">
                  <strong style={{ fontSize: '0.85rem', color: '#64748b', textTransform: 'uppercase' }}>Language & Gen. Studies</strong>
                  <a href="/Subject-Wise/English" style={{ display: 'block', margin: '8px 0', color: '#0f172a', textDecoration: 'none' }}>English Language</a>
                  <a href="/Subject-Wise/Awareness" style={{ display: 'block', margin: '8px 0', color: '#0f172a', textDecoration: 'none' }}>General Awareness</a>
                </div>
                <div className="mobile-catalog-group">
                  <a href="/Subject-Wise/Crux" style={{ display: 'inline-block', backgroundColor: '#eff6ff', color: '#2563eb', padding: '8px 12px', borderRadius: '6px', textDecoration: 'none', fontWeight: 'bold', fontSize: '0.9rem', marginTop: '5px' }}>
                    Explore Crux Notes &rarr;
                  </a>
                </div>
              </div>
            )}
          </div>

          {/* Active Track Mobile Widget */}
          <div style={{ padding: '20px' }}>
            <div style={{ border: '1px solid #e2e8f0', borderRadius: '8px', padding: '15px' }}>
              <div style={{ fontSize: '0.8rem', color: '#2563eb', fontWeight: 'bold', marginBottom: '5px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                <span style={{ width: '8px', height: '8px', backgroundColor: '#2563eb', borderRadius: '50%', display: 'inline-block' }}></span>
                ACTIVE TRACK
              </div>
              <h4 style={{ margin: '0 0 10px 0', fontSize: '0.95rem', color: '#0f172a' }}>Quant: Profit & Loss</h4>
              <div style={{ width: '100%', height: '6px', backgroundColor: '#e2e8f0', borderRadius: '3px', overflow: 'hidden' }}>
                <div style={{ width: '68%', height: '100%', backgroundColor: '#2563eb' }}></div>
              </div>
              <button 
                onClick={() => handleRoute('posts')} 
                style={{ width: '100%', padding: '8px', marginTop: '15px', backgroundColor: '#f1f5f9', border: 'none', borderRadius: '6px', color: '#0f172a', fontWeight: 'bold', cursor: 'pointer' }}
              >
                Resume Learning
              </button>
            </div>
          </div>
        </nav>

        {/* 3. Drawer Footer (Settings & Logout) */}
        <div className="drawer-footer" style={{ borderTop: '1px solid #e2e8f0', padding: '10px 0' }}>
          <button className="drawer-link" onClick={() => handleRoute('profile')}>
            My Profile
          </button>
          <button className="drawer-link" onClick={() => handleRoute('settings')}>
            Account Settings
          </button>
          <button className="drawer-link" onClick={() => handleRoute('contact')}>
            Support & Contact
          </button>
          <button 
            className="drawer-link" 
            style={{ color: '#ef4444' }} 
            onClick={() => {
              onLogout();
              onClose();
            }}
          >
            Sign Out
          </button>
        </div>

      </aside>
    </>
  );
}